module.exports = __webpack_public_path__ + "img/it_it_day-17.91cbf4ae.svg";